module.exports = __webpack_public_path__ + "img/tanza.81cb0698.jpg";